import { DownloadOutlined } from "@ant-design/icons"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { Empty } from "antd"
import QRCode from "react-qr-code"
import { ISimperQr } from "@/types"

interface SimperQrCardProps {
  simperQr: ISimperQr | null
  downloadQRCode: () => void
}

const SimperQrCard = ({ simperQr, downloadQRCode }: SimperQrCardProps) => {
  return (
    <Card className="border-none shadow-sm sticky top-4 overflow-hidden h-fit">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4 bg-muted/20 border-b">
        <CardTitle className="text-xl font-bold text-primary-600">
          QR Code
        </CardTitle>
        {simperQr && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="icon"
                  className="h-8 w-8 text-primary-600" 
                  onClick={downloadQRCode}
                >
                  <DownloadOutlined className="text-lg" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Download QR Code</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </CardHeader>
      <CardContent className="flex flex-col items-center py-8">
        {simperQr ? (
          <>
            <div className="p-4 bg-white border-2 border-primary-600/10 rounded-xl mb-6 shadow-inner ring-4 ring-primary-600/5 transition-all hover:ring-primary-600/10">
              <QRCode 
                id="simper-qr-code"
                value={simperQr.qr_target_url} 
                size={200}
                level="H"
              />
            </div>
            
            <div className="w-full space-y-3">
              <div className="bg-muted/30 p-3 rounded-lg border border-border/50 text-center">
                <span className="text-xs font-bold text-muted-foreground uppercase tracking-wider block mb-1">Target URL</span>
                <a 
                  href={simperQr.qr_target_url} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="text-primary-600 text-xs break-all hover:underline transition-all block font-medium"
                >
                  {simperQr.qr_target_url}
                </a>
              </div>
              
              <Button 
                variant="outline"
                className="w-full mt-4 flex items-center gap-2 border-primary-600/20 text-primary-600 hover:bg-primary-600 hover:text-white transition-all shadow-sm"
                onClick={downloadQRCode}
              >
                <DownloadOutlined />
                Download PNG
              </Button>
            </div>
          </>
        ) : (
          <div className="py-12 flex flex-col items-center justify-center grayscale opacity-60">
            <Empty description="QR Code unavailable" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default SimperQrCard
